const actions = {
  SET_STATE: 'user/SET_STATE',
  // SET_STATE0: 'user/SET_STATE0',
  LOGIN: 'user/LOGIN',
  LOGIN_BY_KEY: 'user/LOGIN_BY_KEY',
  OAUTHLOGIN: 'user/OAUTHLOGIN',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  UPDATE_ALLOWED_DOMAIN: 'user/UPDATE_ALLOWED_DOMAIN',
  LOGOUT: 'user/LOGOUT',
  LOGIN_BY_OTP: 'user/LOGIN_BY_OTP', // /auth/loginwithemail
}

export default actions
